import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  :root {
    --primary-color: #FF8C00;
    --secondary-color: #2E8B57;
    --accent-color: #FFFFFF;
    --background-color: #121212;
    --text-color: #FFFFFF;
    --light-gray: #e0e0e0;
    --medium-gray: #888888;
    --dark-gray: #333333;
    --light-bg: #f9f9f9;
    --card-bg: #FFFFFF;
    --dark-text: #222222;
    --font-main: 'Poppins', sans-serif;
    --font-heading: 'Montserrat', sans-serif;
    --box-shadow: 0 10px 30px rgba(0, 0, 0, 0.4);
    --transition: all 0.3s ease-in-out;
    --gradient: linear-gradient(120deg, #FF8C00, #FF5500);
    --gradient-accent: linear-gradient(120deg, #2E8B57, #1E5631);
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
    font-size: 62.5%;
    scroll-behavior: smooth;
  }

  body {
    font-family: var(--font-main);
    font-size: 1.6rem;
    line-height: 1.7;
    color: var(--text-color);
    background-color: var(--background-color);
    overflow-x: hidden;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: var(--font-heading);
    font-weight: 700;
    line-height: 1.2;
    color: var(--primary-color);
    margin-bottom: 2rem;
  }

  h1 {
    font-size: 4.8rem;
  }

  h2 {
    font-size: 3.6rem;
  }

  h3 {
    font-size: 2.8rem;
  }

  p {
    margin-bottom: 1.6rem;
  }

  a {
    text-decoration: none;
    color: var(--primary-color);
    transition: var(--transition);
  }

  a:hover {
    color: var(--secondary-color);
  }

  img {
    max-width: 100%;
    height: auto;
    display: block;
    visibility: visible !important;
    opacity: 1 !important;
  }

  button, .btn {
    font-family: var(--font-main);
    font-size: 1.6rem;
    font-weight: 600;
    background-color: var(--secondary-color);
    color: white;
    border: none;
    padding: 1.2rem 2.4rem;
    border-radius: 5px;
    cursor: pointer;
    transition: var(--transition);
    display: inline-block;
    box-shadow: 0 5px 15px rgba(19, 196, 163, 0.3);
  }

  button:hover, .btn:hover {
    background-color: var(--primary-color);
    transform: translateY(-3px);
    box-shadow: var(--box-shadow);
  }

  .container {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 2rem;
  }

  .section {
    padding: 8rem 0;
  }

  .section-title {
    text-align: center;
    margin-bottom: 5rem;
  }

  .section-title h2 {
    display: inline-block;
    position: relative;
    margin-bottom: 1rem;
  }

  .section-title h2::after {
    content: '';
    position: absolute;
    bottom: -1rem;
    left: 50%;
    transform: translateX(-50%);
    width: 80px;
    height: 4px;
    background: var(--gradient-accent);
    border-radius: 2px;
  }

  .text-center {
    text-align: center;
  }

  .glassmorphism {
    background: rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.18);
    border-radius: 10px;
    box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.1);
  }

  /* Light mode component overrides - these ensure text is readable on light backgrounds */
  .light-bg {
    background-color: var(--light-bg);
    color: var(--dark-text);
  }

  .light-bg h2, .light-bg h3 {
    color: var(--dark-text);
  }
  
  .light-bg p {
    color: var(--dark-text);
  }

  .card, .white-card {
    background-color: var(--card-bg);
    color: var(--dark-text);
  }
  
  .card h3, .white-card h3 {
    color: var(--dark-text);
  }
  
  .card p, .white-card p {
    color: var(--dark-text);
  }

  /* Fixing image display issues */
  .image-container, [class*="Image"], [class*="image"] {
    display: block !important;
    visibility: visible !important;
    opacity: 1 !important;
  }

  /* Ensure images in cards and other components are visible */
  div[style*="background-image"] {
    display: block !important;
    visibility: visible !important;
    opacity: 1 !important;
  }

  @media screen and (max-width: 768px) {
    html {
      font-size: 55%;
    }
  }

  @media screen and (max-width: 480px) {
    html {
      font-size: 50%;
    }

    h1 {
      font-size: 3.6rem;
    }

    h2 {
      font-size: 2.8rem;
    }

    h3 {
      font-size: 2.4rem;
    }
  }
`;

export default GlobalStyles; 